import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center",
  "data-test-ref": "network-error"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-content-end" }

import { onMounted, ref } from 'vue';

import { useI18n } from '@/i18n';

import { useAppStore } from '@/store';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { createAemService } from '@/composables/aem-service';
import { createProfileService } from '@/composables/profile-service';
import { getSecureAemSiteIdentifier, getSecureAemSiteLanguageCode } from '@/utils/aem';

/*-----------*\
| Composition |
\*-----------*/


export default /*#__PURE__*/_defineComponent({
  __name: 'login-terms-conditions',
  setup(__props) {

const { t } = useI18n();

const appStore = useAppStore();
const nonsecureService = useNonsecureService();
const ledsService = useLedsService();
const aemService = createAemService({
    nonsecureService,
});
const profileService = createProfileService({
    ledsService,
    nonsecureService,
});

/*----*\
| Data |
\*----*/

const hasNetworkError = ref(false);
const loading = ref(false);
const termsConditionsHtml = ref('');

/*---------*\
| Lifecycle |
\*---------*/

onMounted(async () => {
    loading.value = true;
    try {
        await getTermsConditionsText();
    } catch (error) {
        hasNetworkError.value = true;
    } finally {
        loading.value = false;
    }
});

/*-------*\
| Methods |
\*-------*/

async function getTermsConditionsText() {
    const termsConditionsResponse = await aemService.getTermsConditions({
        site: getSecureAemSiteIdentifier(),
        language: getSecureAemSiteLanguageCode(),
    });

    termsConditionsHtml.value = termsConditionsResponse.data.terms;
}

function decline() {
    window.location.href = appStore.logoutUrl ?? 'https://myhealthtoolkit.com';
}

async function accept() {
    loading.value = true;
    hasNetworkError.value = false;
    try {
        await profileService.updateTermsAgreementDate();
        const queryParams = new URLSearchParams();
        const site = getSecureAemSiteIdentifier();
        if (site) {
            // If site isn't passed, Instil theme will flash blue for a split second.
            queryParams.append('site', site);
        }
        window.location.href = 'https://' + window.location.hostname + '/site-router.html?' + queryParams.toString();
    } catch (error) {
        hasNetworkError.value = true;
        window.scrollTo(0, 0);
    } finally {
        loading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(_unref(t)('termsConditions.title')), 1 /* TEXT */),
    (hasNetworkError.value)
      ? (_openBlock(), _createBlock(_component_b_alert, {
          key: 0,
          show: "",
          variant: "danger"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('termsConditions.error.general')), 1 /* TEXT */)
            ])
          ], undefined, true),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_b_spinner)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", {
            class: "my-4",
            "data-test-ref": "terms-content",
            innerHTML: termsConditionsHtml.value
          }, null, 8 /* PROPS */, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_b_button, {
              variant: "outline-primary",
              "data-test-ref": "decline-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (decline()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('termsConditions.decline')), 1 /* TEXT */)
              ], undefined, true),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_button, {
              variant: "primary",
              class: "ml-2",
              "data-test-ref": "accept-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (accept()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('termsConditions.accept')), 1 /* TEXT */)
              ], undefined, true),
              _: 1 /* STABLE */
            })
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})